import Button from 'antd/lib/button';
import styled from 'styled-components';

const ButtonStyled = styled(Button)`
    @media (max-width: 767px) {
        width: 100%;
    }
`;

export const VoteButton = ({ isVoted, onVote }) => {
    if (isVoted) {
        return (
            <ButtonStyled type="default" onClick={onVote}>
                Anuluj głos
            </ButtonStyled>
        );
    }

    return (
        <ButtonStyled type="primary" onClick={onVote}>
            Zagłosuj
        </ButtonStyled>
    );
};

export default VoteButton;
